import "./contact.css";

import React from "react";
import { Helmet } from "react-helmet";

import MainContent from "../general/MainContent";
import BreadCrumbs from "../sections/Breadcrumbs";
import NewsletterForm from "./NewsletterForm";


const Newsletter = () => {
  return (
    <MainContent>
      <Helmet>
        <title>Charles Greig | Newsletter Signup</title>
      </Helmet>

      <BreadCrumbs
        crumbs={[
          { text: "Home", link: "/" },
          { text: "Newsletter Signup", link: "" },
        ]}
      />

      <section className={"contact-store"}>
        <NewsletterForm />
      </section>

    </MainContent>
  );
};

export default Newsletter;

